<div class="wrapper">
  <mat-form-field class="full-width" floatLabel="always">
    <mat-label>{{ label }}</mat-label>

    @if (validUrl) {
      <div class="open-link" title="Open link">
        <button mat-icon-button (click)="openLink()">
          <mat-icon>open_in_new</mat-icon>
        </button>
      </div>
    }

    <app-mat-form-field-wrapper [focused]="false">
      <input
        #inputElement
        [(ngModel)]="value"
        (ngModelChange)="onChange($event)"
        matInput
        type="url"
        placeholder=""
        />
    </app-mat-form-field-wrapper>
  </mat-form-field>
</div>
